import { KEEN_KEY, KEEN_VALUE } from '../../constants';
export var transformFunnel = function (_a) {
    var steps = _a.steps, result = _a.result;
    return ({
        data: steps.map(function (_a, idx) {
            var _b;
            var eventCollection = _a.event_collection;
            return (_b = {},
                _b[KEEN_KEY] = eventCollection,
                _b[KEEN_VALUE] = result[idx],
                _b);
        }),
        keys: [KEEN_VALUE],
    });
};
